import { Component, OnInit, Input } from '@angular/core';
import * as moment from 'moment';
import Changeover from 'src/models/changeover';

@Component({
  selector: 'app-changeover-details',
  templateUrl: './changeover-details.component.html',
  styleUrls: ['./changeover-details.component.scss']
})
export class ChangeoverDetailsComponent implements OnInit {
  @Input()
  public changeover: Changeover | null = null;
  get scheduledTime() { return moment(this.changeover!.scheduledTime).format('LLLL') };

  constructor() { }

  ngOnInit(): void {
  }
}
